module.exports = __webpack_public_path__ + "static/media/21.76f5384f.png";